import URL from '../basUrl';

export const URL_RECEIVED = `${URL.FINANCE_DOCUMENTS}/GetDocumentRequestsHistory`;
export const URL_TYPES = `${URL.FINANCE_DOCUMENTS}/GetDocumentTypes`;
export const URL_DESTIGNATION = `${URL.FINANCE_DOCUMENTS}/GetDestinationTypes`;
export const URL_CREATE = `${URL.FINANCE_DOCUMENTS}/CreateDocumentRequest`;
export const URL_DOWNLOAD = `${URL.FINANCE_DOCUMENTS}/GetDocumentFile`;
